import angular from 'angular';

export const loadModule = () =>
  angular
    .module('app')
    .controller('ContactDetailsCtrl', function ContactDetailsCtrl() {});
